import { render } from "./CommentModal.vue?vue&type=template&id=631e6082&ts=true"
import script from "./CommentModal.vue?vue&type=script&lang=ts"
export * from "./CommentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__